import { configureFetchMs } from '@/epersonam/configureFetchMs';
import { addMinutes, format } from 'date-fns';
import errorManager from '@/rollbar.js';

const updateDataFine = (activitiesConfigId, dataInizioPrevId, dataInizioId, dataFineId, oraInizioPrevId, oraInizioId, oraFineId) => {
  const activitiesConfig = document.getElementById(activitiesConfigId);
  const dataInizioPrev = document.getElementById(dataInizioPrevId);
  const dataInizio = document.getElementById(dataInizioId);
  const dataFine = document.getElementById(dataFineId);
  const oraInizioPrev = document.getElementById(oraInizioPrevId);
  const oraInizio = document.getElementById(oraInizioId);
  const oraFine = document.getElementById(oraFineId);
  const baseUrl = `${window.config.ePersonamService.ePersonamHost}/${window.locale}`;
  const persisted = activitiesConfig.dataset.persisted;
  let duration = 30;

  const changeHour = () => {
    if (persisted === 'true') {
      oraFine.value = '';
    } else {
      let [hours, minutes] = oraInizio.value.split(':').map(Number);

      let startTime = new Date();
      startTime.setHours(hours, minutes);

      let endTime = addMinutes(startTime, duration);
      oraFine.value = format(endTime, 'HH:mm');
    }
  };

  activitiesConfig.onchange = async (event) => {
    try {
      const url = `${baseUrl}/activities_configs/${event.target.value}`;
      const options = configureFetchMs('GET');
      options.headers['Accept'] = 'application/json';

      const response = await fetch(url, options);

      const { timestd } = await response.json();
      duration = timestd || 30;

      changeHour();
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  dataInizioPrev.onchange = () => {
    const dataInizioPrevValue = dataInizioPrev.value;
    dataInizio.value = dataInizioPrevValue;
    dataFine.value = dataInizioPrevValue;
  };

  oraInizioPrev.onchange = (event) => {
    event.stopPropagation();
    const oraInizioPrevValue = oraInizioPrev.value;
    oraInizio.value = oraInizioPrevValue;
    changeHour();
  };

  dataInizio.onchange = () => {
    const dataInizioValue = dataInizio.value;
    dataFine.value = dataInizio.value;
  };

  oraInizio.onchange = (event) => {
    event.stopPropagation();
    changeHour();
  };
};

const init = (activitiesConfig, dataInizioPrevId, dataInizioId, dataFineId, oraInizioPrevId, oraInizioId, oraFineId) => {
  try {
    updateDataFine(activitiesConfig, dataInizioPrevId, dataInizioId, dataFineId, oraInizioPrevId, oraInizioId, oraFineId);
  } catch (e) {
    errorManager(e);
  }
};

window.CalcDataFine = {
  init: init,
};
